import { useEffect, useState } from 'react'

function ownerInitial(owner) {
  const value = String(owner || '').trim()
  return value ? Array.from(value)[0].toUpperCase() : '?'
}

function OwnerAvatar({
  src,
  owner,
  className = '',
  size = 42,
}) {
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setFailed(false)
  }, [src])

  if (!src || failed) {
    return (
      <span
        className={`owner-avatar-placeholder ${className}`.trim()}
        style={{ width: size, height: size }}
        role="img"
        aria-label={`${owner || '项目'}默认头像`}
      >
        {ownerInitial(owner)}
      </span>
    )
  }

  return (
    <img
      className={className}
      src={src}
      alt={`${owner || '项目'}头像`}
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  )
}

export default OwnerAvatar
